module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "notice-title"
  }, [_vm._v(_vm._s(_vm.entity.title))]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 mt-15"
  }, [_vm._v(_vm._s(_vm.entity.createTime))]), _vm._v(" "), _c('div', {
    staticClass: "mt-30 fs-32 color-333"
  }, [_vm._v(_vm._s(_vm.entity.content))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701af5e3","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/My/noticeDetail.vue
// module id = GBsf
// module chunks = 51